import { EmptyContent, imagesUrls, Modal } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import type { FC } from 'react'

export const EmployeeNotAllowed: FC = () => {
  const { t } = usePlanningFormTranslation()
  return (
    <>
      <Modal.Header title='' />
      <div className='flex h-screen w-full items-center justify-center'>
        <EmptyContent
          className='px-6'
          title={t('realHoursForm.notAllowedTitle')}
          desc={t('realHoursForm.notAllowed')}
          imageSrc={imagesUrls.illustrations.buoy}
        />
      </div>
    </>
  )
}
